import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { faEuroSign, faParking } from "@fortawesome/free-solid-svg-icons";
import CardInfo from "src/components/Cards/Info";
import StatChart from "src/components/StatChart";

const RevenueStats = ({ stats }) => {
  const { t } = useTranslation("dashboard");
  const revenueDescription = stats?.statCharts?.find(
    (chart) => chart.type === "revenue"
  )?.description;

  if (stats === null) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <Spinner animation="border" variant="primary" role="status">
          <span className="sr-only">Lade...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <>
      <h2 className="h6 text-muted">{t("stats.current_metrics")}</h2>
      <div className="row">
        <CardInfo
          title="Parkplätze"
          icon={faParking}
          color="info"
          value={`${stats.occupied_parking_slots_count} / ${stats.max_parking_slots}`}
          hint={`Freie Parkplätze: ${stats.unoccupied_parking_slots_count}`}
        />
        <CardInfo
          title="Umsatz heute"
          icon={faEuroSign}
          color="success"
          value={stats.revenue_today}
          hint={`Gestern: ${stats.revenue_yesterday}`}
          infoId="revenue-today"
          description={revenueDescription}
        />
      </div>
      <div className="w-100">
        {stats.statCharts.map((statChart) => (
          <StatChart key={statChart.type} statChart={statChart} />
        ))}
      </div>
    </>
  );
};

export default RevenueStats;
